import React, { createContext, useContext, useMemo } from 'react';

export const WorkspaceContext = createContext({
  workspace: null,
});

export function WorkspaceContextProvider({ workspace, children }) {
  const defaultContext = useContext(WorkspaceContext);

  const context = useMemo(() => {
    return {
      ...defaultContext,
      workspace,
    };
  }, [defaultContext, workspace]);

  return (
    <WorkspaceContext.Provider value={context}>
      {children}
    </WorkspaceContext.Provider>
  );
}

export function useWorkspaceContext() {
  return useContext(WorkspaceContext);
}
